export const PAGINATION_CONST = {
  pageSize: 30,
};
